import {
  Component,
  ChangeDetectionStrategy,
  InputSignal,
  input,
  computed
} from '@angular/core';

export type ListItemType  = 'row' | 'column';

@Component({
  selector: 'td-wb-list-item',
  templateUrl: 'list-item.component.html',
  styleUrls: ['list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.td-wb-list-item--column]': 'isListItemInColumnMode()',
    '[attr.role]': 'role()'
  }
})
export class ListItemComponent {
  listItemType: InputSignal<ListItemType> = input<ListItemType>('row');
  role: InputSignal<string | undefined> = input<string | undefined>('listitem');

  readonly isListItemInColumnMode: () => boolean = computed(() => this.listItemType() === 'column');
}
